import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Accordion } from "react-bootstrap";
import { useContextValues } from "../../context/RouteDataContext.jsx";
import BaseMap from "../map-components/BaseMap.jsx";
import { extractPolylinePaths } from "../map-components/RoutePolyline.jsx";
import { BUS_ROUTE_COLORS } from "../../utils/constants.js";

export default function RouteMap({ scope = "default" }) {
  const {
    routeId,
    directionId,
    mapStops,
    mapData,
    realtimeMapData,
    stopsRealtime,
    vehiclesData,
  } = useContextValues();

  const [activeKey, setActiveKey] = useState("");
  const displayMapData = scope === "realtime" ? realtimeMapData : mapData;
  const displayStops = scope === "realtime" ? stopsRealtime : mapStops;

  const paths = useMemo(() => {
    return extractPolylinePaths(displayMapData, routeId, directionId);
  }, [displayMapData, routeId, directionId]);

  const stops = useMemo(() => {
    if (!Array.isArray(displayStops)) return [];
    return displayStops.map((stop) => ({
      ...stop,
      stop_lat: stop.stop_lat ?? stop.lat ?? null,
      stop_lon: stop.stop_lon ?? stop.lon ?? null,
    }));
  }, [displayStops]);

  return (

    <Row className="mb-4">
      <Col>
        <Accordion activeKey={activeKey} onSelect={setActiveKey} className="ictapp__map ictapp__route-map darken">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              {activeKey === "0" ? (
                <>
                  <i className="fas fa-chevron-up" aria-hidden="true" /> Close Map
                </>
              ) : (
                <>
                  <i className="fas fa-chevron-down" aria-hidden="true" /> Open Map
                </>
              )}
            </Accordion.Header>
            <Accordion.Body style={{ padding: 0 }} inert={activeKey !== "0"} aria-hidden={activeKey !== "0"}>
              <BaseMap
                paths={paths}
                stops={stops}
                vehicles={vehiclesData}
                showStops
                showVehicles={scope !== "schedule"}
                showStartEndLabels
                stopInfoDirectionId={directionId}
                fitKey={`route-${routeId}-${scope}`}
                polylineColor={BUS_ROUTE_COLORS["default"].background}
                polylineOutlineColor={BUS_ROUTE_COLORS["default"].outline}
                polylineKeyPrefix={`route-${routeId}`}
                polylineIsActive
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
    </Row>
  );
}
